import Keycloak from 'keycloak-js';
import singletonSession from 'src/services/IntanceSession';

let keycloak = new Keycloak({
  "url": process.env.REACT_APP_HOST_KEYCLOAK+":"+process.env.REACT_APP_PORT_KEYCLOAK,
  "realm": "Icintracom",
  "clientId": 'icintracom_app'
});

const initKeycloak = (onAuthenticatedCallback) => {
    keycloak
        .init({
            onLoad: "login-required",
            checkLoginIframe: false,
        })
        .then((auth) => {
            if (!auth) {
                console.error("¡Usuario NO permitido!");
                return;
            }

            const user = keycloak.tokenParsed?.preferred_username;
            singletonSession.setUser(user)
            localStorage.setItem("username", user);
            localStorage.setItem("accessToken", keycloak.token);

            // Actualizar token dentro de keycloak cada cierto tiempo
            setInterval(() => {
                keycloak
                    .updateToken(60)
                    .then((refreshed) => {
                        if (refreshed) {
                            window.localStorage.setItem("session", keycloak.token);
                        }
                    })
                    .catch(() => {
                        console.error("Error al refrescar token");
                    });
            }, 30000);

            onAuthenticatedCallback();
        })
        .catch((error) => console.error(error));
};

const doLogin = keycloak.login;
const doLogout = () =>
    keycloak.logout({
        redirectUri: window.location.origin
    });

const isLoggedIn = ()=> !!keycloak.token;
const getToken = () => keycloak.token;
const getUsername = () => keycloak.tokenParsed?.given_name;
const gerUser = () => keycloak.tokenParsed?.preferred_username;
const getModules = ()=> keycloak.idTokenParsed?.modulos;
const getUserID = ()=> keycloak.idTokenParsed?.sub;
const authServerUrl = ()=> keycloak.authServerUrl;
const realm = () => {
  return keycloak.realm;
}
const updateToken = (calback) => keycloak.updateToken(5)
  .then(calback)
  .catch(doLogin)

const UserService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getUserID,
  getUsername,
  getModules,
  getToken,
  authServerUrl,
  realm,
  updateToken,
  gerUser
};


export default UserService;
